module.exports = __webpack_public_path__ + "static/img/thumb_8.da5d849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_8.jpg
// module id = +dNE
// module chunks = 0